import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import app from 'flarum/forum/app';
import NagusiBackNav from '../common/NagusiBackNav';
import HelpData from '../HelpData';
export default class HelpSectionPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loadSection();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    const newSlug = m.route.param('slug');
    if (this.section && this.section.slug !== newSlug) {
      this.loadSection();
      m.redraw();
    }
  }
  loadSection() {
    const clubSlug = app.forum.attribute('nagusiMatchRatingsClubSlug') || 'athletic';
    const slug = m.route.param('slug') || "ayuda-aurrera-".concat(clubSlug);
    this.section = HelpData().find(s => s.slug === slug || slug.startsWith('ayuda-aurrera-') && s.slug.startsWith('ayuda-aurrera-'));
    if (this.section) {
      app.setTitle(this.section.title + ' - Ayuda');
    } else {
      m.route.set(app.route('nagusi.tutorials.ayuda'));
    }
  }
  view() {
    if (!this.section) return null;
    return m("div", {
      className: "HelpPage HelpSectionPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: app.route('nagusi.tutorials.ayuda'),
      parentLabel: "Centro de Ayuda",
      title: this.section.title
    }), m("article", {
      className: "HelpArticle card"
    }, m("header", {
      className: "HelpArticle-header"
    }, m("div", {
      className: "HelpArticle-icon"
    }, m("i", {
      className: this.section.icon
    })), m("h1", null, this.section.title)), m("div", {
      className: "HelpArticle-body"
    }, this.section.content()), m("footer", {
      className: "HelpArticle-footer"
    }, m("p", null, "\xBFTe ha servido de ayuda esta p\xE1gina? Si tienes m\xE1s dudas, puedes preguntar en el foro."), m(LinkButton, {
      href: app.route('index'),
      className: "Button Button--primary"
    }, "Volver al Foro")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/tutorials/HelpSectionPage', HelpSectionPage);